export default "__VITE_ASSET__Hmd62qeV__";